// ** Reactstrap Imports
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Form,
  Label,
  Input,
} from "reactstrap";

const CheckboxBasic = (props) => {
  return (

    <div className="form-check form-check-inline">
      <Input
        type="checkbox"
        id="basic-cb-unchecked"
        onChange={props.onChange}
        checked={props.checked}
        defaultChecked={props.defaultChecked}
      />
    </div>
  );
};
export default CheckboxBasic;
